let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8V9UV")).then(() => parcelRequire('2tTvg'));